module.exports = __webpack_public_path__ + "assets/img/link_img_c.8fa726b7.png";